import DeductionReportComponent from 'components/Report/DeductionReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path if necessary

const DeductionReport = () => {
	return (
		<PermissionGuard permission="Allow_Earning_and_Deduction_Reports">
			<DeductionReportComponent />
		</PermissionGuard>
	);
};

export default DeductionReport;
